export * as editor from '@wix/auto_sdk_urls_editor/meta';
export * as site from '@wix/auto_sdk_urls_site/meta';
